<script lang="ts">
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import UserSettingsLegacy from './UserSettingsLegacy.svelte';
	import UserSettingsV2 from './UserSettingsV2.svelte';
</script>

{#if $showNewLayout}
	<UserSettingsV2 />
{:else}
	<UserSettingsLegacy />
{/if}
